export function setStreamingPlaylist(videoJsWrapper,playlist){

    let newPlaylist=_generatePlaylist(playlist);

    videoJsWrapper.videojs.concat({
        manifests: newPlaylist,
        callback: (err, result) => {
            if(err){
                console.error(err);
                return;
            }
            videoJsWrapper.videojs.src({
                src:`data:application/vnd.videojs.vhs+json,${JSON.stringify(result.manifestObject)}`,
                type:'application/vnd.videojs.vhs+json',
            });
        }
    });    
}

function _generatePlaylist(playlist){
    let playlistUrls=[];
    playlist.forEach(function(item){
        if(item.URL!==null && item.URL!==undefined){
            let mimeType='application/x-mpegURL';
            if(item.URL.toLowerCase().search(".mpd")!=-1)
                mimeType='application/dash+xml'; //change if the stream is an MPEG-DASH
            playlistUrls.push({url:item.URL,mimeType:mimeType});
        }
    });
    return playlistUrls;
}